import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "goalField", "addButton"]

  connect() {
    this.goalIndex = this.goalFieldTargets.length
    this.maxGoals = 5
    this.updateAddButtonVisibility()
  }

  addGoal(event) {
    event.preventDefault()

    if (this.goalFieldTargets.length >= this.maxGoals) return

    const newGoalField = this.createGoalField(this.goalIndex)
    this.containerTarget.insertAdjacentHTML('beforeend', newGoalField)
    this.goalIndex++

    this.updateAddButtonVisibility()

    // Focus on the new input
    const newInput = this.containerTarget.lastElementChild.querySelector('input')
    if (newInput) newInput.focus()
  }

  removeGoal(event) {
    event.preventDefault()

    const goalField = event.target.closest('[data-goals-form-target="goalField"]')
    if (goalField && this.goalFieldTargets.length > 1) {
      goalField.remove()
      this.reindexGoals()
      this.updateAddButtonVisibility()
    }
  }

  createGoalField(index) {
    return `
      <div class="goal-field" data-goals-form-target="goalField">
        <div class="flex gap-2">
          <input type="text"
                 name="goals[${index}][content]"
                 class="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                 placeholder="e.g., Develop a daily meditation practice">
          <button type="button"
                  data-action="click->goals-form#removeGoal"
                  class="px-3 py-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </button>
        </div>
      </div>
    `
  }

  reindexGoals() {
    this.goalFieldTargets.forEach((field, index) => {
      const input = field.querySelector('input')
      if (input) {
        input.name = `goals[${index}][content]`
      }
    })
    this.goalIndex = this.goalFieldTargets.length
  }

  updateAddButtonVisibility() {
    if (this.hasAddButtonTarget) {
      if (this.goalFieldTargets.length >= this.maxGoals) {
        this.addButtonTarget.style.display = 'none'
      } else {
        this.addButtonTarget.style.display = 'inline-block'
      }
    }
  }
}